<template>
  <div class="home" ref="holder">

    <div class="home--bg">
      <div class="wrap-bg" :style="{backgroundImage: `url(${sourcesBg[currentBgStep].bgImg})`}"></div>
      <div class="wrap-bg" :style="{backgroundImage: `url(${sourcesBg[bgStep].bgImg})`}"></div>
    </div>
    <Loader 
      v-if="isLoading && arrayImages !== null" 
      :arrayImgs="arrayImages"
      :endLoading="triggerEndLoading"
    />
    <div class="home--content" v-if="!isLoading">
      <ChatWrap 
        v-if="introEnd" 
        :introEnd="introEnd" 
        :isFromMenu="isFromMenu"
        :resetMenuHistory="resetMenuHistory"
      />
      <Intro v-if="!introEnd" :fnEnd="triggerEnd" />
      <DishesWrap 
        v-if="openOverlayType === 'openVirtualDishes' "
        :startDishesOverlay="startDishesOverlay"
        :isOverlay="true"
      />
      <CardsGameWrap 
        v-if="openOverlayType === 'openCardsGame' "
        :startCardsOverlay="startCardsOverlay"
        :isOverlay="true"
      />
      <PyramidWrap
        v-if="openOverlayType === 'openPyramid' "
        :startPyramid="startPyramid"
        :isOverlay="true"
      />
    </div>

  </div>
</template>

<script>
// @ is an alias to /src

import {mapState} from 'vuex'
import Loader from '@/components/Loader.vue'
import ChatWrap from '@/components/ChatWrap.vue'
import Intro from '@/components/Intro.vue'
import DishesWrap from '@/components/DishesWrap.vue'
import CardsGameWrap from '@/components/CardsGameWrap.vue'
import {HomeBg} from '@/homeBg.js'
import PyramidWrap from '@/components/PyramidWrap.vue'
import {gsap, Power3} from 'gsap';

export default {
  name: 'Home',
  components: {
    Loader,
    Intro,
    ChatWrap,
    DishesWrap,
    CardsGameWrap,
    PyramidWrap
  },
  data(){
    return{
      introEnd: false,
      isLoading: true,
      arrayImages: [
        HomeBg[0].bgImg,
        HomeBg[1].bgImg,
        HomeBg[2].bgImg,
        HomeBg[3].bgImg,
        HomeBg[4].bgImg
      ],
      startDishesOverlay: false,
      startCardsOverlay: false,
      startPyramid: false,
      isFromMenu: false,
      currentBgStep: 0,
      sourcesBg: HomeBg
    }
  },
  methods: {
    scrollWindow(val){
      let finalVal = val;
      let objScroll = {
        valueScroll: window.scrollY
      };

      gsap.to(objScroll,{
        duration: .75,
        valueScroll:finalVal, 
        ease: Power3.easeOut,
        onUpdate :function () {
          window.scroll(0, objScroll.valueScroll);
        }
     });
      
    },
    triggerEnd(){
      this.introEnd = !this.introEnd
      this.$store.dispatch('setMenuCtaVisibility',true);
    },
    triggerEndLoading(){
      this.isLoading = false;
    },
    openOverlayChat(){
      
      if(this.openOverlayType === 'openVirtualDishes'){
        setTimeout(() => this.startDishesOverlay = true, 500)
      }else if(this.openOverlayType === 'openCardsGame'){
        
        setTimeout(() => this.startCardsOverlay = true, 500)
      }else if (this.openOverlayType === 'openPyramid'){
        setTimeout(() => this.startPyramid = true, 500)
      }
    },
   
    resetMenuHistory(){
      this.isFromMenu = false
    },
    transitionBg() {
      var bgs = document.querySelectorAll('.wrap-bg');
      
      gsap.to(bgs[1], {opacity: 1, duration: 0.75, ease: 'Power2.easeInOut', 
        onComplete: () =>{
          this.currentBgStep = this.bgStep;
          
          setTimeout(() =>{
            
            gsap.set(bgs[1], {opacity: 0, })
          }, 1000)
        }
      })
    }
  },
  computed:{
    ...mapState({
      scrollValue: state => state.scrollValue,
      openOverlayType: state => state.openOverlayType,
      chatNavigationMenu: state => state.chatNavigationMenu,
      chatStep: state => state.chatStep,
      bgStep: state => state.bgStep,
      currentBgStepReload: state => state.currentBgStepReload
    })
  },
  watch: {
    scrollValue(value){
      this.scrollWindow(value)
    },
    openOverlayType(type){
      this.openOverlayChat()
    },
    bgStep(value){      
      this.transitionBg()
    },
    currentBgStep(value){

    }
  },
  beforeMount(){
    this.isFromMenu = this.$route.params.isFromMenu;
    if(this.isFromMenu) this.triggerEnd()
  }
}
</script>

<style lang="scss">
  .home{
    position: relative;
    width: 100%;
    background: #3C4F9B;
    padding: 50px 0;
    min-height: calc(100vh - 100px);
    .home--bg{
      position: fixed;
      height: 100vh;
      width: 100%;
      top: 0;
      background-position: 50%;
      background-size: cover;
      opacity: 0;
      transition: opacity .5s ease-in;
    }
    
    &.chatStarted{
      .home--bg{
        opacity: 1;
      }
    }
    .wrap-bg{
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0; 
      left: 0;
      background-size: cover;
      background-position: 50%;
      &:nth-child(2){
        opacity: 0;
      }
    }
    
      
  }
</style>
